export default __webpack_public_path__ + "static/monikaHalan-3742a769c6f327336e6d0a20105e191c.jpg";